export const scriptId = 'captcha-script';
export const aliyunCaptchaElementId = 'aliyun-captcha-element';
export const aliyunCaptchaTriggerId = 'aliyun-captcha-trigger';
